import Carousel from "..";
import mount from "../../../../lib/mount";

mount(Carousel, "recent-listing-carousel");
